import { Route } from "react-router-dom";
import EnterpriseView from "../views/EnterpriseView";


// Enterprise offers: building, sending and following them. Root only for now -- the page
// itself checks, and so does the hub.
function EnterpriseRoutes() {
    return (
        [
            <Route key="enterprise" path="/enterprise" element={<EnterpriseView />} />
        ]
    );
}

export default EnterpriseRoutes;
